import { AxiosResponse } from 'axios'

import { BulkHistoryDataFilters, DataUploadHistoryType } from '@types'

import { api } from './axios'

export interface BulkDataUploadType {
  file: File
}
export interface BulkDataUploadResponse {
  data?: {
    id: number
    status: string
  }
  msg: string
  fileName: string
  length: number
  code?: string
}
export interface GetBulkDataHistoryResponse {
  sapTptImportHistory?: DataUploadHistoryType
}
const uploadBulkData = async (payload: File) => {
  const fileContainer = new FormData()
  fileContainer.append('tptFile', payload)
  const response = await api.post<BulkDataUploadResponse>('/sap-tpt', fileContainer, {
    headers: {
      'Content-Type': 'multipart/form-data',
      Accept: '*/*',
    },
  })

  return response.data
}

type Params = {
  filters?: BulkHistoryDataFilters
}

const getBulkDataHistory = async (params: Params) => {
  const { filters } = params
  const response = await api.get<GetBulkDataHistoryResponse>('/log-sap-tpt-import', {
    params: {
      ...filters,
      orderBy: 'DESC',
    },
  })
  return response.data
}

const syncContracts = async () => {
  const response = await api.patch('/sap-items')
  return response.data
}

const getBillingBatchExcel = async (id: number) => {
  try {
    const response = await api.get(`/billing-batch/excel/${id}`, {
      responseType: 'blob',
    })
    return response?.data
  } catch (error) {
    console.error('Error al obtener los lotes:', error)
    throw error
  }
}

const getBillingBatchCsv = async (id: number): Promise<Blob> => {
  try {
    const response: AxiosResponse<Blob> = await api.post(
      '/billing-batch/csv',
      { billingBatchId: id },
      { responseType: 'blob' },
    )
    return response.data
  } catch (error) {
    console.error('Error al obtener los lotes:', error)
    throw error
  }
}

const updateBillingBatch = async (id: number) => {
  try {
    const response = await api.post('/billing-batch', {
      carrier: {
        id,
      },
    })
    return response?.data
  } catch (error) {
    console.error('Error al obtener los lotes:', error)
    throw error
  }
}

const inputHes = async (hes: string, id: number) => {
  try {
    const response = await api.put(`/billing-batch/certify/${id}`, {
      hes,
    })
    return response?.data
  } catch (error) {
    console.error('Error al obtener los lotes:', error)
    throw error
  }
}

export const DataApi = {
  uploadBulkData,
  getBulkDataHistory,
  syncContracts,
  getBillingBatchExcel,
  getBillingBatchCsv,
  updateBillingBatch,
  inputHes,
}
